import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/popupTemplates";
import Form from "./form";
import List from "./list";
import Show from "./show";

export default function PopupTemplates(props) {
    useEffect(() => {
        return () => props.clearParams("popup-templates");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Шаблоны pop-up уведомлений"
                            nofilter
                            createBtnText="Создать шаблон pop-up уведомления"
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Show
                            {...rest}
                            transition="full"
                            title="Шаблон pop-up уведомления"
                            back={back}
                            source={source}
                        />
                    )}
                />
                <Route
                    path={`${match.path}/new`}
                    render={() => (
                        <Form {...props} title="Создать шаблон pop-up уведомления" back={back} submit={source.apply} />
                    )}
                />
            </Switch>
        </div>
    );
}
